import { Link,  generatePath, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";

function SuccessPage() {
    const { clientNameParam } = useParams();
  
  return (
    <div style={{ textAlign: "center", marginTop: "70px" }}>
      <FontAwesomeIcon
        icon={faCircleCheck}
        style={{ color: "#4caf4f", fontSize: "5rem", marginBottom: "2rem" }}
      />
      <h1>Payment Successful!</h1>
      <p style={{ marginBottom: "35px" }}>
        Thank you for your purchase. Your transaction has been completed
        successfully.
      </p>
      <Link to={generatePath("/client/:clientNameParam/clientDashboard", {
                                  clientNameParam,
                                })} className="btn btn-primary">
        Go to Dashboard
      </Link>
    </div>
  );
}

export default SuccessPage;
